<template>
    <v-card outlined class="estilo-resumen" :loading="loading">
      <v-card-title> Estado de contratos </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <resumen-contrato
              nombre="Mantenimiento"
              clase="mantenimiento"
              :contrato="mantenimiento"
            ></resumen-contrato>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <resumen-contrato
              nombre="Pack"
              clase="pack"
              :contrato="pack"
            ></resumen-contrato>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <resumen-contrato
              nombre="Cloud"
              clase="cloud"
              :contrato="cloud"
            ></resumen-contrato>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <resumen-contrato
              nombre="Hosting"
              clase="hosting"
              :contrato="hosting"
            ></resumen-contrato>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <resumen-contrato
              nombre="Secure"
              clase="secure"
              :contrato="secure"
            ></resumen-contrato>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <resumen-contrato
              nombre="Backup online"
              clase="backup"
              :contrato="backup"
            ></resumen-contrato>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <resumen-contrato
              nombre="Desarrollo"
              clase="desarrollo"
              :contrato="desarrollo"
            ></resumen-contrato>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
</template>
<script>
import ResumenContrato from "../resumen/resumenContrato";
import { mapGetters } from 'vuex';
export default {
    name: 'ResumenCliente',
    components: {
      ResumenContrato,
    },
    props: ['loading'],
    data() {
      return {
                
      }
    },
    methods: {
      filtrarContrato(contratos, idContrato){
        let contrato = contratos.find(contrato => contrato.contrato_id === idContrato);
        return contrato;
      },
      horasContratadasContrato(idContrato) {
        let contrato = this.estadoContratos.find( contrato => contrato.contrato_id === idContrato);
        if (contrato) {
          return contrato.horasContratadas;
        }
        return 0;
      }
    },
    computed: {
       ...mapGetters({
          estadoContratos: "contratos/estadoContratos"
      }),
      mantenimiento(){
        console.log(this.estadoContratos.length);
        if(this.estadoContratos.length){
          let contrato = this.filtrarContrato(this.estadoContratos, 2); // 2 Integral (Mantenimiento)
          return contrato;
        }
      },
      pack(){
        if(this.estadoContratos.length){
          let contrato = this.filtrarContrato(this.estadoContratos, 3); // 3 Pack
          return contrato;
        }
      },
      cloud(){
        if(this.estadoContratos.length){
          let contrato = this.filtrarContrato(this.estadoContratos, 1); // 3 Cloud
          return contrato;
        }
      },
      hosting(){
        if(this.estadoContratos.length){
          let contrato = this.filtrarContrato(this.estadoContratos, 4); // 4 Hosting
          return contrato;
        }
      },
      secure(){
        if(this.estadoContratos.length){
          let contrato = this.filtrarContrato(this.estadoContratos, 5); // 5 Secure
          return contrato;
        }
      },
      backup(){
        if(this.estadoContratos.length){
          let contrato = this.filtrarContrato(this.estadoContratos, 6); // 6 Backup
          return contrato;
        }
      },
      desarrollo(){
        if(this.estadoContratos.length){
          let contrato = this.filtrarContrato(this.estadoContratos, 8); // 8 Desarrollo
          return contrato;
        }
      },
    }
    
}
</script>
<style>
.estilo-resumen .v-text-field input {
  font-size: 2.2em;
}
.v-application .mantenimiento {
  color: #a991d4 !important;
  caret-color: #a991d4 !important;
}
.estilo-resumen .mantenimiento .v-messages__message {
  color: #a991d4;
}
.v-application .pack {
  color: #bcb01b !important;
  caret-color: #bcb01b !important;
}
.estilo-resumen .pack .v-messages__message {
  color: #bcb01b;
}
.v-application .cloud {
  color: #f39c12 !important;
  caret-color: #f39c12 !important;
}
.estilo-resumen .cloud .v-messages__message {
  color: #f39c12;
}
.v-application .hosting {
  color: #0cb658 !important;
  caret-color: #0cb658 !important;
}
.estilo-resumen .hosting .v-messages__message {
  color: #0cb658;
}
.estilo-resumen .v-messages__message {
  text-align: end;
}
.estilo-resumen .v-text-field__slot > input {
  text-align: end;
}
.centradoVertical {
  width: max-content;
  display: flex;
}
</style>